export default __webpack_public_path__ + "static/buy-book-covers@2x-e7cd6cb1d10aa321cdaa71112e264c81.png";